import { useTheme } from 'styled-components'
import { type Surface } from '@shipt/design-system-themes'
import { type SemanticBackgroundColor } from '@/features/cms/components/CMS/types'
import { logWarn } from '@/features/shared/utils/logger'

export const useDeriveColorProps = (
  color: SemanticBackgroundColor,
): { color: string; surface: Surface } => {
  const theme = useTheme()

  switch (color) {
    case 'neutral-default':
      return {
        color: theme.color.background.base.neutral.default,
        surface: 'default',
      }
    case 'neutral-subtle':
      return {
        color: theme.color.background.base.neutral.subtle,
        surface: 'default',
      }
    case 'brand-primary-heavy':
    case 'brand-primary':
      return {
        color: theme.color.background.base.brand.primary,
        surface: 'inverse',
      }
    case 'brand-secondary':
      return {
        color: theme.color.background.base.brand.secondary,
        surface: 'default',
      }
    case 'marketing-orange-normal':
      return {
        color: '#eb6a00',
        surface: 'default',
      }
    case 'marketing-yellow-normal':
      return {
        color: '#ffc500',
        surface: 'default',
      }
    default:
      logWarn(
        `Received unrecognized color value: ${color}. Falling back to default background color.`,
      )
      return {
        color: theme.color.background.base.neutral.default,
        surface: 'default',
      }
  }
}
